import { ThemeProvider } from '@material-ui/core';
import React from 'react';

import { sochiLightTheme } from '../sochi-light';

export const SochiThemeContainer = ({ children }: { children: React.ReactNode }) => {
    return <ThemeProvider theme={sochiLightTheme}>{children}</ThemeProvider>;
};
